module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/qr-code-plp-marketting-tile-d00e3b4d1a98e80abab074282f80b77e.jpg";